import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import WarehousingForm from "./WarehousingComponents/WarehousingForm";

import {
  useGetWarehousingDetailQuery,
  useUpdateWarehousingMutation,
} from "store/services/warehousingApi";

const WarehousingEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Warehousing", path: "/app/crm/warehousing/list" },
    { title: "Edit Warehousing" },
  ];

  const {
    data: warehousingDetail,
    isLoading: loadingWarehousing,
    error,
  } = useGetWarehousingDetailQuery(id);

  const [updateWarehousing, { isLoading: updatingWarehousing }] =
    useUpdateWarehousingMutation();

  const handleUpdateWarehousing = async (data) => {
    const _payload = { ...data };

    try {
      await updateWarehousing(_payload).unwrap();
      toast.success("Warehousing successfully updated!");
      navigate(`/app/crm/warehousing/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Warehousing!"
      );
    }
  };

  useAppMeta("Edit Warehousing");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingWarehousing || updatingWarehousing}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <WarehousingForm
          isBusy={loadingWarehousing || updatingWarehousing}
          warehousingDetail={warehousingDetail}
          onSubmit={handleUpdateWarehousing}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default WarehousingEditScreen;
